module.exports = {"header":"ElT_Header","footer":"ElT_Footer","banner":"ElT_Banner","product":"ElT_Product","products-list":"ElT_ProductsList","recommended":"ElT_Recommended","newsletter":"ElT_Newsletter","blog":"ElT_Blog","manufacturer":"ElT_Manufacturer","brand":"ElT_Brand","cart":"ElT_Cart","textElement":"ElT_TextElement","info-banner":"ElT_InfoBanner"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/creator/typeTranslations.json
// module id = 54
// module chunks = 0